import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

export const updateDomainType = async (domainId: string, domainType: string): Promise<void> => {
  try {
    const operations = [
      {
        op: 'replace',
        path: '/domainType',
        value: domainType,
      },
    ];

    await openMetadataApiClient.patch(`/domains/${domainId}`, operations, {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    });
  } catch (error) {
    console.error('Failed to update domain type:', error);
    throw error;
  }
};
